import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { Carrito, Carrito2 } from '../models/carrito.model';
import { Entrada } from '../models/entrada.model';
import { SidebarNavigationService } from 'src/app/shared/services/sidebar-navigation.service';
import moment from 'moment';
import 'moment/min/locales';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { shareReplay, map, first, catchError, tap } from 'rxjs/operators';;
import { AppConfiguration } from 'src/app/app.configuration';
import { ConfigurationService } from 'src/app/core/conf/configuration.service';
import { InsUpdContactoAlbaranModel } from '../models/ins-upd-contacto-albaran-model';
import { RecintosService } from './recintos.service'; 
import { SinpeVinculacionResponse } from '../../tienda/models/entrada.microservicio.model';
import { MonedasBilletesChequeVaccanceListado, MonedasBilletesChequeVaccanceResponse, ObtenerCustomanFormaPago, ObtenerCustomanFormaPagoResponse } from '../models/pago.model';

@Injectable({
  providedIn: 'root'
})
export class VentaService {
  private readonly reservaAforoErrorCodes = new Set([
    'VA01', 'VA02', 'VA03', 'VA04', 'VA05',
    'VA06', 'VA07', 'VA08', 'VA09', 'VA10',
    '-1', '-2', '-3', '-4', '0'
  ]);
  private readonly reservaAforoErrorI18nMap = {
    VA01: 'RESERVA_AFORO.VA01',
    VA02: 'RESERVA_AFORO.VA02',
    VA03: 'RESERVA_AFORO.VA03',
    VA04: 'RESERVA_AFORO.VA04',
    VA05: 'RESERVA_AFORO.VA05',
    VA06: 'RESERVA_AFORO.VA06',
    VA07: 'RESERVA_AFORO.VA07',
    VA08: 'RESERVA_AFORO.VA08',
    VA09: 'RESERVA_AFORO.VA09',
    VA10: 'RESERVA_AFORO.VA10',
    '-1': 'RESERVA_AFORO.NEG1',
    '-2': 'RESERVA_AFORO.NEG2',
    '-3': 'RESERVA_AFORO.NEG3',
    '-4': 'RESERVA_AFORO.NEG4',
    '0': 'RESERVA_AFORO.ZERO'
  };
  public carritoSubject: BehaviorSubject<any>;
  carrito: Observable<any>;
//<< Yaribel 20210210  Añadimos observable para el carrito original de la reserva
  public carritoOrigenSubject:BehaviorSubject<any>;
  carritoOrigen: Observable<any>;
// Yaribel 20210210 >>
  private clienteSeleccionadoSubject: BehaviorSubject<any>;
  public clienteSeleccionado: Observable<any>;

  private fechaSeleccionadaSubject: BehaviorSubject<any>;
  public fechaSeleccionada: Observable<any>;

  private cantidadVentasSubject: BehaviorSubject<any>;
  public cantidadVentas: Observable<any>;

  private disabledDaysSubject: BehaviorSubject<any>;
  public disabledDays: Observable<any>;
    //<<Yaribel 20210730 añadimos los observables para gestionar el descuento cliente mapfre VSTS 8370
    private hayDescuentoSubject: BehaviorSubject<boolean>;
    public hayDescuento$: Observable<boolean>;
    //Yaribel 20210730 añadimos los observables para gestionar el descuento cliente mapfre VSTS 8370 >>

   private masEntradasSubject: BehaviorSubject<any>;
   public masEntradas$: Observable<any>;
   private urlApi = "";


   private otherFopData: ObtenerCustomanFormaPago[] = [];
   private monedasBilletesChequeVaccance: MonedasBilletesChequeVaccanceListado[] = [];
    
  idioma = 'es-ES';
  paseHorario = true;
  carritoModificado;
  currentRecinto: any;
  currentCliente = '0';
  productoYEntradas = '';
  verCalendario = new BehaviorSubject(false);
  entradasArrCompleto = new BehaviorSubject(undefined);
  entradasArrNominativas = new BehaviorSubject(undefined);
  irPago: boolean;
  isVentaSinFechaChecked: boolean = false;
  public idMarcadoExterno :string = null;

  constructor(
    private sidebarNavigation: SidebarNavigationService,
    private http: HttpClient,
    private config: AppConfiguration,
    private configuration: ConfigurationService,
    private recintosService: RecintosService,
    
  ) {
    
    this.carritoSubject = new BehaviorSubject(new Carrito());
    this.carrito = this.carritoSubject.asObservable();
//<< Yaribel 20210210  Añadimos observable para el carrito original de la reserva
    this.carritoOrigenSubject = new BehaviorSubject(new Carrito());
    this.carritoOrigen = this.carritoOrigenSubject.asObservable();
// Yaribel 20210210 
    this.clienteSeleccionadoSubject = new BehaviorSubject('');
    this.clienteSeleccionado = this.clienteSeleccionadoSubject.asObservable();

    this.fechaSeleccionadaSubject = new BehaviorSubject(moment());
    this.fechaSeleccionada = this.fechaSeleccionadaSubject.asObservable();

    this.cantidadVentasSubject = new BehaviorSubject(0);
    this.cantidadVentas = this.cantidadVentasSubject.asObservable();

    this.disabledDaysSubject = new BehaviorSubject([]);
    this.disabledDays = this.disabledDaysSubject.asObservable();
    //<<Yaribel 20210730 añadimos los observables para gestionar el descuento cliente mapfre VSTS 8370
    this.hayDescuentoSubject = new BehaviorSubject(false);
    this.hayDescuento$ = this.hayDescuentoSubject.asObservable();
        //Yaribel 20210730 añadimos los observables para gestionar el descuento cliente mapfre VSTS 8370

    this.masEntradasSubject = new BehaviorSubject('');
    this.masEntradas$ = this.masEntradasSubject.asObservable();

    this.urlApi = this.config.getConfig("API_URL_MS");

  }


public get masEntradasValue(){
  return this.masEntradasSubject.value;
}
public setMasEntradas(valor)
{
  this.masEntradasSubject.next(valor);
}

    // << Yaribel 20210730 añadimos los observables para gestionar el descuento cliente mapfre VSTS 8370
    public get hayDescuentoValue() {
      return this.carritoValue.hayDescuento;
    }
    // << Yaribel 20210730 añadimos los observables para gestionar el descuento cliente mapfre VSTS 8370
    public setHayDescuento(descuento) {
      this.carritoValue.hayDescuento = descuento;
      this.hayDescuentoSubject.next(descuento);
    }
  public get disabledDaysValue() {
    return this.disabledDaysSubject.value;
  }

  setDisabledDays(disabledDays) {
    this.disabledDaysSubject.next(disabledDays);
  }

  public get cantidadVentasValue() {
    return this.cantidadVentasSubject.value;
  }

  setCantidadVentas(qty) {
    this.cantidadVentasSubject.next(qty);
  }

  actualizarCantidadVentas(qty) {
    const cantidadActualizar = this.cantidadVentasSubject.value + qty;
    this.cantidadVentasSubject.next(cantidadActualizar);
  }

  public get clienteSeleccionadoValue() {
    return this.clienteSeleccionadoSubject.value;
  }

  setClienteSeleccionadoValue(cliente) {
    // Asegurar que siempre se incluyan los campos necesarios para la inserción de venta
    /*let clienteCompleto = cliente;
    
    if (typeof cliente === 'string' || !cliente) {
      // Si es un string vacío o null/undefined, crear objeto por defecto
      clienteCompleto = { 
        Codigo: '0',
        NombreCliente: '', // Nombre vacío por defecto
        FP_Id: '1', // Forma de pago por defecto
        FP_Facturar: '0', // No generar factura por defecto
        ConDescuento: 'False', // Sin descuento por defecto
        Dto: '0' // Descuento 0 por defecto
      };
    } else if (typeof cliente === 'object') {
      // Si es un objeto, asegurar que tenga los campos necesarios
      clienteCompleto = {
        Codigo: cliente.Codigo || '0',
        NombreCliente: cliente.NombreCliente || '', // Nombre por defecto
        FP_Id: cliente.FP_Id || '1', // Forma de pago por defecto
        FP_Facturar: cliente.FP_Facturar || '0', // No generar factura por defecto
        ConDescuento: cliente.ConDescuento || 'False', // Sin descuento por defecto
        Dto: cliente.Dto || '0', // Descuento 0 por defecto
        // Preservar otros campos si existen
        ...cliente
      };
    }*/
    
    this.clienteSeleccionadoSubject.next(cliente);
  }

  public get fechaSeleccionadaValue() {
    return this.fechaSeleccionadaSubject.value;
  }

  setFechaSeleccionadaValue(fecha = moment(), isfechaEmpty = false) {
    if(isfechaEmpty) {
      this.fechaSeleccionadaSubject.next('');
      this.isVentaSinFechaChecked = true;
    } else {
      this.fechaSeleccionadaSubject.next(fecha);
      this.isVentaSinFechaChecked = false;
    }
  }

  public get carritoValue() {
    return this.carritoSubject.value;
  }

  setCarrito(carrito) {
    this.carritoSubject.next(carrito);
    this.carritoModificado = true;
  }
//<< Yaribel 20210210  Añadimos observable para el carrito original de la reserva
  public get carritoOrigenValue() {
    return this.carritoOrigenSubject.value;
  }

  setCarritoOrigen(carrito) {
    this.carritoOrigenSubject.next(carrito);
  }
// Yaribel 20210210 >>

  setCarritoPromocionalValue(carritoPromocionalValue: Carrito, carritoOrigen: Carrito) {
      const carritoFinal = carritoOrigen;
      carritoFinal.setCarritoModificacionValue(carritoPromocionalValue);
      this.carritoSubject.next(carritoFinal);
      this.carritoModificado = true;
  }
  //<< Yaribel 20210210  Añadimos observable para el carrito original de la reserva
  setCarritoReservaPagadaFinalValue(carritoOrigen: Carrito, carritoModificado: Carrito)
  {
    //Comparar las entradas del carrito origen y
    //dejar solo las entradas nuevas añadidas para pagar 
    

  }
  // Yaribel 20210210 >>


  clearCarrito() {
    this.carritoValue.resetearCarrito();
    this.currentRecinto = undefined;
    this.setCarrito(this.carritoValue);
    if(this.carritoOrigenValue){ 
      this.setCarritoOrigen(new Carrito());
    }
    this.sidebarNavigation.unblockSecciones();
  }

  /**
   * Limpia el carrito preservando las entradas de amigos thyssen
   */
  clearCarritoPreservandoAmigosThyssen() {
    // Guardar entradas de amigos thyssen
    const entradasAmigosThyssen = this.carritoValue.entradas.filter(entrada => 
      entrada.entrada.DNIAbonadosExt && entrada.entrada.DNIAbonadosExt !== ''
    );

    // Limpiar el carrito
    this.carritoValue.resetearCarrito();
    
    // Restaurar entradas de amigos thyssen directamente
    if (entradasAmigosThyssen.length > 0) {
      entradasAmigosThyssen.forEach(entrada => {
        // Restaurar directamente sin usar agregarEntrada para evitar validaciones
        this.carritoValue.entradas.push(entrada);
      });
      // Recalcular totales después de restaurar
      this.carritoValue.recalcularTotales();
    }

    this.setCarrito(this.carritoValue);
    if(this.carritoOrigenValue){ 
      this.setCarritoOrigen(new Carrito());
    }
    this.sidebarNavigation.unblockSecciones();
  }

  getCantidadPorEntrada(entrada: Entrada) {
    // if(this.carritoValue.reservaPagada == '1' && this.carritoOrigen){
    //   const cantidad = this.carritoValue.getCantidadPorEntrada(entrada) - this.carritoOrigenValue.getCantidadPorEntrada(entrada);
    //   return cantidad;
    // }
    return this.carritoValue.getCantidadPorEntrada(entrada);
  }

  getCantidadEntradasPorMotivo(entrada: Entrada, motivo) {
    return this.carritoValue.getCantidadEntradasPorMotivo(entrada, motivo);
  }

  sendEntrada(entrada: Entrada) {
    // Preservar el campo DNIAbonadosExt si viene de amigos thyssen
    if (entrada.DNIAbonadosExt) {
      // Asegurar que la entrada mantenga la información del amigo thyssen
      // El campo DNIAbonadosExt ya está en la entrada, solo necesitamos preservarlo
    }
    
    this.carritoValue.agregarEntrada(entrada);
    this.setCarrito(this.carritoValue);
    this.sidebarNavigation.blockSecciones();
  }

  /**
   * Elimina filas de `carrito.horarios` por índice. Orden descendente evita que al
   * hacer `splice` se desplacen índices pendientes; deduplica índices repetidos.
   * El patrón anterior (`if (indice > 0) indice--` + `splice`) borraba una posición
   * a la izquierda del objetivo (p. ej. otro recinto).
   */
  private spliceHorariosCarritoPorIndices(indicesEliminar: number[]): void {
    const horarios = this.carritoValue?.horarios as any[] | undefined;
    if (!indicesEliminar?.length || !horarios?.length) {
      return;
    }
    [...new Set(indicesEliminar)]
      .filter((i) => Number.isFinite(i) && i >= 0 && i < horarios.length)
      .sort((a, b) => b - a)
      .forEach((indice) => {
        horarios.splice(indice, 1);
      });
  }

  /** Para selector-entradas: misma lógica que sendEntradas al invalidar horarios. */
  public eliminarHorariosCarritoPorIndicesPublic(indicesEliminar: number[]): void {
    this.spliceHorariosCarritoPorIndices(indicesEliminar);
  }

  /** Códigos Recinto de la línea en carrito (no la plantilla completa del catálogo). */
  public codigosRecintoLineaParaHorariosPublic(entrada: Entrada): string[] {
    return this.obtenerCodigosRecintoParaInvalidarHorarios(entrada);
  }

  /**
   * Resuelve códigos `Recinto` de la línea en carrito (y rama usada) para invalidar horarios.
   */
  private resolveCodigosRecintoDebug(entrada: Entrada): {
    codes: string[];
    branch: string;
    plantillaRecintosN: number;
  } {
    const toCodes = (recintos: any[] | undefined): string[] =>
      (recintos || [])
        .map((r: any) => String(r?.Recinto ?? ''))
        .filter((c) => c !== '');
    const plantillaRecintosN = entrada?.recintos?.length ?? 0;
    const rows = this.carritoValue?.entradas as any[] | undefined;
    if (!entrada) {
      return { codes: [], branch: 'sin-entrada', plantillaRecintosN };
    }
    if (rows?.length) {
      const byRef = rows.find((r) => r?.entrada === entrada);
      if (byRef?.entrada?.recintos?.length) {
        return {
          codes: toCodes(byRef.entrada.recintos),
          branch: 'carrito-misma-ref',
          plantillaRecintosN,
        };
      }
      const idT = String(entrada.idTarifa ?? '');
      const idRb = String(entrada.idRecintoButaca ?? '');
      if (idT) {
        const sameTarifa = rows.filter(
          (r: any) => r?.entrada && String(r.entrada.idTarifa) === idT
        );
        if (idRb !== '') {
          const hit = sameTarifa.find(
            (r: any) => String(r.entrada.idRecintoButaca ?? '') === idRb
          );
          if (hit?.entrada?.recintos?.length) {
            return {
              codes: toCodes(hit.entrada.recintos),
              branch: 'carrito-tarifa+idRecintoButaca',
              plantillaRecintosN,
            };
          }
        } else if (sameTarifa.length === 1 && sameTarifa[0].entrada?.recintos?.length) {
          return {
            codes: toCodes(sameTarifa[0].entrada.recintos),
            branch: 'carrito-tarifa-unica-linea',
            plantillaRecintosN,
          };
        }
      }
    }
    return {
      codes: toCodes(entrada.recintos),
      branch: 'plantilla-entrada.recintos',
      plantillaRecintosN,
    };
  }

  private obtenerCodigosRecintoParaInvalidarHorarios(entrada: Entrada): string[] {
    return this.resolveCodigosRecintoDebug(entrada).codes;
  }

  sendEntradas(entrada: Entrada, cantidad: number) {
    if (this.carritoValue.horarios.length > 0
      && this.carritoValue.entradasPrevias && this.carritoValue.entradasPrevias.length > 0) {
      let entradaPreviaE: any = null;
        this.carritoValue.entradasPrevias.forEach (entradaPrevia => {
          if (entradaPrevia.entrada.idTarifa == entrada.idTarifa) {
            
            entradaPreviaE = entradaPrevia;
          }
        });
      if (entradaPreviaE) {
        if (cantidad >= Number.parseInt(entradaPreviaE.cantidad, 10)) {
          const codigosRecinto = this.obtenerCodigosRecintoParaInvalidarHorarios(entrada);
          const indicesEliminar = [];
          if (entrada.TipoProducto === '1') {
          this.carritoValue.horarios.forEach((item, index) => {
            if (codigosRecinto.includes(item.sesion.RecintoId.toString())) {
              // item.cantidad = item.cantidad + 1;
              
              if (item.sesion.RecintosSesionId) {
                this
                  .eliminarAforoSesion(item.sesion.RecintosSesionId)
                  .subscribe(data => { });
                  indicesEliminar.push(index);
              } else {
                indicesEliminar.push(index);
              }
            }
          });
          } else if (entrada.TipoProducto === '2') {
            entrada.PromocionEntradas.forEach(item => {
              const recintosAnadir = [...codigosRecinto];
              this.carritoValue.horarios.forEach((item2, index) => {
                if (recintosAnadir.includes(item2.sesion.RecintoId.toString()) &&
                  item2.recinto.entradas.includes(item.TipoEntradaId)) {
                  
                  // item.cantidad = item.cantidad + 1;
                  if (item2.sesion.RecintosSesionId) {
                    this
                    .eliminarAforoSesion(item2.sesion.RecintosSesionId)
                    .subscribe(data => {});
                    indicesEliminar.push(index);
                  } else {
                    indicesEliminar.push(index);
                  }
                }
              });
            });
          }
          if (indicesEliminar.length > 0) {
            this.spliceHorariosCarritoPorIndices(indicesEliminar);
          }
        } else if (cantidad < Number.parseInt(entradaPreviaE.cantidad, 10)) {
          const recintosEliminar = this.obtenerCodigosRecintoParaInvalidarHorarios(entrada);
          const indicesEliminar = [];
          
          // 
          const cantidadEliminada = Number.parseInt(entradaPreviaE.cantidad, 10) - cantidad;
          this.carritoValue.horarios.forEach((item, index) => {
            if (recintosEliminar.includes(item.recinto.Recinto)) {
              if (item.cantidadxentrada && item.cantidadxentrada.length > 0) {
                // 
                if (!entradaPreviaE.entrada.Caracteristicas || entradaPreviaE.entrada.Caracteristicas.NumPeriodos == '') {
                  
                  if (item.cantidad - cantidadEliminada > 0) {
                    item.cantidad = item.cantidad - cantidadEliminada;
                    item.resumen = `${item.recinto.NombreRecinto} - ${moment(
                      this.fechaSeleccionadaValue,
                      'YYYY/MM/DD'
                    )
                      .locale(this.idioma)
                      .format('L')} ${item.sesion.HoraInicio} (${item.cantidad})`;
                      // this
                      // .reservaAforo(item.sesion.RecintosSesionId, item.cantidad, entradaPreviaE.TipoEntradaId)
                      // .subscribe();
                      //el metodo espera un array y por aqui solo para uno
                      let tmpArrEntradas = [];
                      tmpArrEntradas.push(entradaPreviaE);
                      this
                      .reservaAforoProductos(this.mapeaListaentradas2ListaProductos(entradaPreviaE), 
                      item.recinto.Recinto, this.fechaYYYYMMDD2slash(item.sesion.Fecha, item.sesion.HoraInicio) )
                      .subscribe();
                  } else {
                    
                    this
                    .eliminarAforoSesion(item.sesion.RecintosSesionId)
                    .subscribe(data => {});
                    indicesEliminar.push(index);
                  }
                } else {
                  
                  if (item.cantidadxentrada.length > 0) {
                    for (const entradaR of item.cantidadxentrada) {
                      if (entradaR.entrada.TipoEntradaId ==  entradaPreviaE.TipoEntradaId) {
                        // this
                        // .reservaAforo(item.sesion.RecintosSesionId, entradaR.cantidad - cantidadEliminada, entradaPreviaE.TipoEntradaId)
                        // .subscribe();
                        let tmpArrEntradas = [];
                        let tmpEntrada = entradaPreviaE;
                        tmpEntrada.cntidad = entradaR.cantidad - cantidadEliminada;
                        tmpArrEntradas.push(tmpEntrada);
                        this
                        .reservaAforoProductos(this.mapeaListaentradas2ListaProductos(entradaPreviaE), 
                        item.recinto.Recinto, this.fechaYYYYMMDD2slash(item.sesion.Fecha, item.sesion.HoraInicio) )
                        .subscribe();
                      }
                    }
                  }
                }
              } else {
                if (item.cantidad - cantidadEliminada > 0) {
                  item.cantidad = item.cantidad - cantidadEliminada;
                  item.resumen = `${item.recinto.NombreRecinto} - ${moment(
                    this.fechaSeleccionadaValue,
                    'YYYY/MM/DD'
                  )
                    .locale(this.idioma)
                    .format('L')} ${item.sesion.HoraInicio} (${item.cantidad})`;
                   // <<Yaribel 20210112 cambiamos peticion para que llame a reservaAforoProductos

                  //   //JS 20200812 MAntenemos el Metodo API ya que no hay productos
                  // this.reservaAforo(item.sesion.RecintosSesionId, item.cantidad)
                  // .subscribe();
                  this
                  .reservaAforoProductos(this.mapeaListaentradas2ListaProductos(entradaPreviaE), 
                  item.recinto.Recinto, this.fechaYYYYMMDD2slash(item.sesion.Fecha, item.sesion.HoraInicio) )
                  .subscribe();

                  // Yaribel 20210112 >>
                } else {
                  this
                  .eliminarAforoSesion(item.sesion.RecintosSesionId)
                  .subscribe(data => {});
                  indicesEliminar.push(index);
                }
              }
            }
          });
          if (indicesEliminar.length > 0) {
            this.spliceHorariosCarritoPorIndices(indicesEliminar);
          }
        }
      }
    } else {
        const codigosRecintoLinea = this.obtenerCodigosRecintoParaInvalidarHorarios(entrada);
        const indicesEliminar = [];
        if (entrada.TipoProducto === '1') {
        this.carritoValue.horarios.forEach((item, index) => {
          if (codigosRecintoLinea.includes(item.sesion.RecintoId.toString())) {
            // item.cantidad = item.cantidad + 1;
            
            if (item.sesion.RecintosSesionId) {
              this
                .eliminarAforoSesion(item.sesion.RecintosSesionId)
                .subscribe(data => { });
                indicesEliminar.push(index);
            } else {
              indicesEliminar.push(index);
            }
          }
        });
        } else if (entrada.TipoProducto === '2') {
          entrada.PromocionEntradas.forEach(item => {
            const recintosAnadir = [...codigosRecintoLinea];
            this.carritoValue.horarios.forEach((item2, index) => {
              if (recintosAnadir.includes(item2.sesion.RecintoId.toString()) &&
                item2.recinto.entradas.includes(item.TipoEntradaId)) {
                
                // item.cantidad = item.cantidad + 1;
                if (item2.sesion.RecintosSesionId) {
                  this
                  .eliminarAforoSesion(item2.sesion.RecintosSesionId)
                  .subscribe(data => {});
                  indicesEliminar.push(index);
                } else {
                  indicesEliminar.push(index);
                }
              }
            });
          });
        }
        if (indicesEliminar.length > 0) {
          this.spliceHorariosCarritoPorIndices(indicesEliminar);
        }
    }
    this.carritoValue.agregarEntradas(entrada, cantidad);
    this.setCarrito(this.carritoValue);
    this.sidebarNavigation.blockSecciones();
  }

  removeEntrada(entrada: Entrada) {
    
    this.carritoValue.eliminarEntrada(entrada);
    this.setCarrito(this.carritoValue);
  }

  /**
   * Iguala la suma en cantidadxentrada del horario con la línea del carrito para esa idTarifa
   * (misma lógica que el resumen tras la cruz; evita drift entre sesiones y el carrito).
   */
  sincronizarCxeHorarioConCarrito(horarioItem: any, idTarifa: string): void {
    if (!idTarifa || !horarioItem?.cantidadxentrada?.length) {
      return;
    }
    const ceList = horarioItem.cantidadxentrada;
    const sumaCxe = ceList
      .filter((ce: any) => String(ce?.entrada?.idTarifa ?? '') === idTarifa)
      .reduce((s: number, ce: any) => s + Number(ce?.cantidad || 0), 0);
    const filaCarrito = (this.carritoValue?.entradas || []).find(
      (e: any) => e?.entrada && String(e.entrada.idTarifa) === idTarifa
    );
    const cantCarrito = filaCarrito != null ? Number(filaCarrito.cantidad || 0) : null;
    if (cantCarrito === null || sumaCxe === cantCarrito) {
      return;
    }
    const otros = ceList.filter((ce: any) => String(ce?.entrada?.idTarifa ?? '') !== idTarifa);
    const plantilla = ceList.find((ce: any) => String(ce?.entrada?.idTarifa ?? '') === idTarifa);
    if (!plantilla) {
      return;
    }
    if (cantCarrito <= 0) {
      horarioItem.cantidadxentrada = otros.filter((ce: any) => Number(ce?.cantidad || 0) > 0);
      return;
    }
    horarioItem.cantidadxentrada = [...otros, { ...plantilla, cantidad: cantCarrito }].filter(
      (ce: any) => Number(ce?.cantidad || 0) > 0
    );
  }

  getFechasFestivas(fecha, tipo = 1) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const fechaDesde = moment(fecha)
      .startOf('year')
      .format('YYYY/MM/DD hh:mm:ss');
    const fechaHasta = moment(fecha)
      .endOf('year')
      .format('YYYY/MM/DD hh:mm:ss');
    const body = {
      ConexionIacpos: conexionId,
      FechaDesde: fechaDesde,
      FechaHasta: fechaHasta,
      Tipo: tipo
    };
    return this.http
      .post(`${this.config.getConfig('API_URL')}api/HIBDatosFestivos`, body)
      .pipe(shareReplay(1));
  }

  getCalendario(TPVId, recinto, fecha, cliente, filtrarPorCliente, items) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      RecintoId: recinto,
      EsVentaTaquilla: '1',
      Fecha: moment(fecha)
        .startOf('month')
        .format('YYYY/MM/DD'),
      FechaHasta: moment(fecha)
        .endOf('month')
        .format('YYYY/MM/DD'),
      TPVId: TPVId,
      CodigoCliente: cliente,
      FiltrarPorCliente: filtrarPorCliente,
      TipoProducto: '0',
      Items: items
    };
    return this.http.post(
      `${this.config.getConfig('API_URL')}api/DisponibilidadCalendario`,
      body
    );
  }

  getTiposEntradaDatos() {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId
    };
    return this.http
      .post(
        `${this.config.getConfig(
          'API_URL'
        )}api/Configuracion/GetTiposEntradaDatos`,
        body
      )
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            return {};
          }
          return res.DatosResult;
        })
      );
  }

  getTemporadas() {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId
    };
    return this.http
      .post(
        `${this.config.getConfig(
          'API_URL'
        )}api/Configuracion/GetTemporadas`,
        body
      )
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            return {};
          }
          return res.DatosResult;
        })
      );
  }

  reservaAforo(sesion, cantidad, entradaId?) {
    const identificadorUnico = this.configuration.datosTPVPathValue.pkId;
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      IdentificadorUnico: identificadorUnico,
      Sesion: sesion,
      Cantidad: cantidad,
      Taquilla: 1,
      IdEntrada: entradaId
    };
    return this.http.post(
      `${this.config.getConfig('API_URL')}api/ReservaAforo`,
      body
    );
  }

  async reservaAforoaAsincrono(sesion, cantidad, entradaId?) {
    const identificadorUnico = this.configuration.datosTPVPathValue.pkId;
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      IdentificadorUnico: identificadorUnico,
      Sesion: sesion,
      Cantidad: cantidad,
      Taquilla: 1,
      IdEntrada: entradaId
    };
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/ReservaAforo`,
        body
      )
      .pipe(
        map((res: any) => {
          if (res.DatosResult) {
            return res.DatosResult;
          }
          return [];
        })
      ).toPromise();
  }

  reservaAforoProductos(productos, recinto, fechaHora, idSesion?) {
    const identificadorUnico = this.configuration.datosTPVPathValue.pkId;
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      IdentificadorUnico: identificadorUnico,
      listadoProductos: productos,
      Recinto: recinto,
      FechaHora: fechaHora,
      Plataforma: 2,
      IdSesion: idSesion
    };
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/ReservaAforoProductos`,
        body
      )
      .pipe(
        map((res: any) => {
          if (!this.esReservaAforoProductosValida(res)) {
            throw this.crearErrorReservaAforo(res);
          }
          return res;
        }),
        catchError((error: any) => {
          if (error && error.codigo && error.i18nKey) {
            return throwError(error);
          }

          const codigo = error?.error?.Mensajes?.[0]?.CodigoMensaje?.toString?.() || 'HTTP';
          const i18nKey = this.reservaAforoErrorI18nMap[codigo] || 'RESERVA_AFORO.DEFAULT';
          const mensaje =
            error?.error?.Mensajes?.[0]?.DescripcionMensaje ||
            error?.message ||
            'Error técnico al reservar aforo';

          return throwError({
            codigo,
            i18nKey,
            mensaje,
            respuesta: error
          });
        })
      );
  }

  private crearErrorReservaAforo(res: any) {
    const codigo = res?.Mensajes?.[0]?.CodigoMensaje?.toString?.() || '0';
    return {
      codigo,
      i18nKey: this.reservaAforoErrorI18nMap[codigo] || 'RESERVA_AFORO.DEFAULT',
      mensaje:
        res?.Mensajes?.[0]?.DescripcionMensaje ||
        'No se ha podido reservar aforo para los productos seleccionados.',
      respuesta: res
    };
  }

  private esReservaAforoProductosValida(res: any): boolean {
    if (!res) {
      return false;
    }

    if (res.DatosResult === null || res.DatosResult === false) {
      return false;
    }

    const codigo = res?.Mensajes?.[0]?.CodigoMensaje?.toString?.();
    if (codigo && this.reservaAforoErrorCodes.has(codigo)) {
      return false;
    }

    const productos = res?.DatosResult?.Producto;
    return Array.isArray(productos) && productos.length > 0;
  }

  async reservaAforoProductosAsincrono(productos, recinto, fechaHora, idSesion?) {
    const identificadorUnico = this.configuration.datosTPVPathValue.pkId;
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      IdentificadorUnico: identificadorUnico,
      ListadoProductos: productos,
      Recinto: recinto,
      FechaHora: fechaHora,
      Plataforma: 2,
      IdSesion: idSesion
    };
    return this.http.post(
      `${this.config.getConfig('API_URL')}api/ReservaAforoProductos`,
      body
    ).pipe(
      map((res: any) => {
        if (res.DatosResult) {
          return res.DatosResult;
        }
        return [];
      })
    ).toPromise();
  }

  eliminarAforoSesion(sesion) {
    const identificadorUnico = this.configuration.datosTPVPathValue.pkId;
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      SesionInternetId: identificadorUnico,
      Accion: 3,
      RecintosSesionesId: sesion
    };
    return this.http.post(
      `${this.config.getConfig('API_URL')}api/CancelarReservaAforo`,
      body
    );
  }

  eliminaReservaAforoCompleto() {
    const identificadorUnico = this.configuration.datosTPVPathValue.pkId;
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      SesionInternetId: identificadorUnico,
      Accion: 0,
      RecintosSesionesId: ''
    };
    return this.http.post(
      `${this.config.getConfig('API_URL')}api/CancelarReservaAforo`,
      body
    );
  }

  insUpdContactoAlbaran(contacto: InsUpdContactoAlbaranModel) {
    const identificadorUnico = this.configuration.datosTPVPathValue.pkId;
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      TPV: contacto.TPV,
      NumAlbaran: contacto.NumAlbaran,
      Nombre: contacto.Nombre,
      CIF: contacto.CIF,
      Email: contacto.Email,
      Telefono: contacto.Telefono,
      Fax: contacto.Fax,
      Domicilio: contacto.Domicilio,
      Localidad: contacto.Localidad,
      Pais: contacto.Pais,
      CP: contacto.CP,
      Apellido1: contacto.Apellido1,
      Apellido2: contacto.Apellido2,
      Provincia: contacto.Provincia,
      FechaNacimiento: contacto.FechaNacimiento,
      Sexo: contacto.Sexo,
      PublicidadInterna: contacto.PublicidadInterna ? 1 : 0,
      Contacto: contacto.Contacto,
      TipoPolitica: 0,
      EnlacePolitica: contacto.EnlacePolitica,
      NombreProyecto: 'TAQUILLA',
      NombreFormulario: 'modal-contacto.component',
      Notas: contacto.Notas,
      Pregunta1: contacto.Pregunta1,
      Respuesta1: contacto.Respuesta1,
      Pregunta2: contacto.Pregunta2,
      Respuesta2: contacto.Respuesta2,
      Pregunta3: contacto.Pregunta3,
      Respuesta3: contacto.Respuesta3,
      Pregunta4: contacto.Pregunta4,
      Respuesta4: contacto.Respuesta4,
    };
    return this.http.post(
      `${this.config.getConfig('API_URL')}api/VentaTaquilla/InsUpdContactoAlbaran`,
      body
    ).pipe(
      map((res: any) => {
        return res;
     }));
  }

  //Modificar todas las tarifas del carrito para reflejar un cambio de fecha
  async modificarTarifasFecha(fecha: string) {
    if (fecha && this.carritoValue && this.carritoValue.entradas && this.carritoValue.entradas.length > 0 && !this.carritoValue.entradas[0].entrada.idRecintoButaca) {
      // 
      this.carritoValue.entradas.forEach(async elemento => {
        
        //Guardamos los recintos Calculados
        elemento.fecha = fecha;
        let promocionEntrada = elemento.entrada.PromocionEntradas;

        // manieva - no se usaban
        // let reservaRecintos = elemento.entrada.recintos;
        // let reservaCaracteristicasEntrada = elemento.entrada.CaracteristicasEntrada;
        // let reservaFiltrosCaracteristica = elemento.entrada.FiltrosCaracteristicas;
        // let reservaEntradasVendidasPersona = elemento.entrada.EntradasVendidasPersonas;
        // let reservaListaButacas = elemento.entrada.ListaButacas;
        // let reservaNumOrdenPromos = elemento.entrada.NumOrdenPromos;
        // let reservaNumOrdenPromosConEntradas = elemento.entrada.NumOrdenPromosConEntradas;
        // let reservaPosicionesVenta = elemento.entrada.PosicionesVenta;
        // let reservaFarId = elemento.entrada.FarId;
        // let DNIAbonadosExt = elemento.entrada.DNIAbonadosExt;
        // let desdeAsociado = elemento.entrada.desdeAsociado;
        // let codigoAsociado = elemento.entrada.codigoAsociado;

        //Cambiamos los elementos de tarifa
        let idProducto = elemento.entrada.TipoProducto && elemento.entrada.TipoProducto == "2" ? elemento.entrada.TipoPromocionId : elemento.entrada.TipoEntradaId;
        
        await this.recalcularTarifaxCambioFecha(elemento.entrada.TipoProducto, idProducto, fecha)
          .toPromise()
          .then(entradas => {
            if (entradas && entradas.length > 0) { //Yaribel 20220331 Comprobamos si tenemos tarifa para el dia seleccionado
              entradas.forEach(entradaNuevoPrecio => {
                // Preservar DNIAbonadosExt para entradas de amigos thyssen
                const dniAbonadosExt = elemento.entrada.DNIAbonadosExt;
                elemento.entrada = { ...elemento.entrada, ...entradaNuevoPrecio };
                if (dniAbonadosExt && dniAbonadosExt !== '') {
                  elemento.entrada.DNIAbonadosExt = dniAbonadosExt;
                }
                if (promocionEntrada) {
                  //Recuperamos las EVPersonas de la reserva por idEntrada
                  promocionEntrada.forEach(entradaPromocion => {
                    elemento.entrada.PromocionEntradas.find(x => x.TipoEntradaId == entradaPromocion.TipoEntradaId).EntradasVendidasPersonas = entradaPromocion.EntradasVendidasPersonas;
                  });
                }
              });

            } else if ((!this.carritoValue.localizador || this.carritoValue.localizador != undefined) && !this.carritoValue.albaran) {
              
              //manieva 11595
              //cuando es combinada podemos estar ante un espectaculo
              //en una fecha diferente
              if (!elemento.entrada.idRecintoButaca) {
                // NO poner cantidad en 0 para entradas de amigos thyssen
                const esEntradaAmigosThyssen = elemento.entrada.DNIAbonadosExt && elemento.entrada.DNIAbonadosExt !== '';
                if (!esEntradaAmigosThyssen) {
                  elemento.cantidad = 0; //Yaribel 20220331 Quitamos las entradas si no tenemos tarifa para ese dia
                }
              }

            }

          });
        // 

        this.carritoValue.recalcularTotales();
      });
    }
  }

    //Modificar las tarifas del carrito cuando cambia de fecha en selector de horarios
    async modificarTarifasFechaXSesiones(fecha:string)
    {
      if (fecha && this.carritoValue && this.carritoValue.entradas && this.carritoValue.entradas.length >0)
      {
        // 
        this.carritoValue.entradas.forEach(async elemento => {
          elemento.fecha = fecha;
          //Guardamos los recintos Calculados
          let reservaEntradasVendidasPersonaPromocionesxPromocion = elemento.entrada.PromocionEntradas;
  
          //Cambiamos los elementos de tarifa
          let idProducto = elemento.entrada.TipoProducto && elemento.entrada.TipoProducto == "2"? elemento.entrada.TipoPromocionId: elemento.entrada.TipoEntradaId;
          await this.recalcularTarifaxCambioFecha(elemento.entrada.TipoProducto,idProducto, fecha).toPromise()
          .then(entradas => {
            entradas.forEach(entradaNuevoPrecio => {
              // Preservar DNIAbonadosExt para entradas de amigos thyssen
              const dniAbonadosExt = elemento.entrada.DNIAbonadosExt;
              elemento.entrada = {...elemento.entrada,...entradaNuevoPrecio};
              if (dniAbonadosExt && dniAbonadosExt !== '') {
                elemento.entrada.DNIAbonadosExt = dniAbonadosExt;
              }
              if (reservaEntradasVendidasPersonaPromocionesxPromocion)
              {
                //Recuperamos las EVPersonas de la reserva por idEntrada
                reservaEntradasVendidasPersonaPromocionesxPromocion.forEach(entradaPromocion => {
                  elemento.entrada.PromocionEntradas.find(x => x.TipoEntradaId == entradaPromocion.TipoEntradaId).EntradasVendidasPersonas = entradaPromocion.EntradasVendidasPersonas;
                });
              }
              
            });
          });
          // 
          
          this.carritoValue.recalcularTotales();
        });
      }
    }

  recalcularTarifaxCambioFecha(tipoproducto, entradasString, fecha, cliente?) { 
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      TPVId: this.configuration.datosTPVPathValue.pkId,
      Fecha: fecha,
      TipoProducto: tipoproducto,
      CodigoCliente: cliente ? cliente.Codigo : this.clienteSeleccionadoValue ? this.clienteSeleccionadoValue.Codigo : '0',
      FiltrarPorCliente: 0,
      Items: '[' + tipoproducto +','+ entradasString + ']'
    };
    
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/GetKoreTarifasDisponibles`,
        body
      )
      .pipe(
        map((res: any) => {
          if (res.DatosResult) {
            return res.DatosResult.ListadoKoreTarifasDisponibles;
          }
          return [];
        })
      );
  }

  getCaracteristicasxEntrada(entrada: Entrada) {
    return this.carritoValue.getCaracteristicasxEntrada(entrada);
  }

  mapeaListaentradas2ListaProductos( listaentradas, filtroProducto?) :string[]
  {
    let respuesta:string[] = [];
    listaentradas.forEach(element => {
      let idProducto = "";
      if (element.entrada.TipoProducto == "2")
        {
          if (!filtroProducto ||  filtroProducto == element.entrada.TipoPromocionId)
          idProducto = "2," + element.entrada.TipoPromocionId + "," + element.cantidad.toString();
        }
        else if (element.entrada.TipoProducto == "3")
        {
          if (!filtroProducto ||  filtroProducto == element.entrada.TipoAbonadoId)
          idProducto = "3," + element.entrada.TipoAbonadoId + "," + element.cantidad.toString();
        }
        else
        {
          if (!filtroProducto ||  filtroProducto == element.entrada.TipoEntradaId)
          idProducto = "1," + element.entrada.TipoEntradaId + "," + element.cantidad.toString();
        }
      respuesta.push(idProducto);
    });
    //if (respuesta.length > 0) respuesta = respuesta.slice(0, -1); 
    return respuesta;
  }

  fechaYYYYMMDD2slash(fecha, hora)
  {
    let respuesta = "";
    if (fecha && fecha.length == 8)
      {
        respuesta = fecha.substring(0, 4) + "/" + fecha.substring(4,6) + "/" + fecha.substring(6);
      } 
    if (hora && hora.length == 5)
      {
        respuesta = respuesta + " " + hora + ":00";
      }
      else if (hora && hora.length == 8)
      {
        respuesta = respuesta + " " + hora;
      }
      else 
      {
        respuesta = respuesta + " " + "23:59:00";
      }
      return respuesta;
  } 

  calcularDescuentoCliente(){

    this.carritoValue.calcularDescuento();
  }

  mapHorarios(recintos) {
    const aforos = new Array();
    const aforosProducto = recintos.map((e, index) => {
      return {
        cantidad: e.CantidadXRecinto || e.CantidadTotal,
        index: index,
        recinto: {
          obligatorio: (e.ControlaAforoVenta && e.ControlaAforoVenta == '1') || (e.ControlaAforoReserva && e.ControlaAforoReserva == '1') ? true : false,
          Activo: '1',
          CodigoTipoControl: '',
          ControlaAforo: e.ControlaAforoVenta? e.ControlaAforoReserva: '',
          ControlaAforoReserva: '',
          ControlaNumSesion: '0',
          DisponibleInternet: '',
          EsActividad: '',
          NombreRecinto: e.RecintoNombre,
          Recinto: e.RecintoId,
          TiempoExtra: '0',
          TieneButacas: '0',
          TipoAforo: '',
          TipoEntrada: e.ItemId,
          entradas: recintos.filter(x => x.RecintoId == e.RecintoId && x.FechaEntrada == e.FechaEntrada).map( p => p.ItemId),
          fecha: moment(e.FechaEntrada, 'YYYY/MM/DD HH:mm:ss').format('YYYY/MM/DD'),
          sesiones: [],
          ControlAforoExterno: ''
        },
        resumen: `${e.RecintoNombre} - ${moment(
          e.FechaEntrada,
          'YYYY/MM/DD'
        )
          .locale(this.idioma)
          .format('L')} ${moment(
            e.FechaEntrada,
            'YYYY/MM/DD HH:mm:ss'
          )
            .locale(this.idioma)
            .format('HH:mm')} (${(e.CantidadXRecinto?e.CantidadXRecinto:e.CantidadTotal)})`,
        sesion: {
          Activa: 1,
          ControlaGrupo: 0,
          Disponible: 0,
          DisponibleInternet: 0,
          Fecha: moment(e.FechaEntrada, 'YYYY/MM/DD HH:mm:ss').format('YYYYMMDD'),
          FranjaHorario: '',
          HoraFin: '',
          HoraInicio: moment(e.FechaEntrada, 'YYYY/MM/DD HH:mm:ss').format('HH:mm'),
          LimiteAforo: null,
          MaximoAforo: 0,
          MaximoInternet: 0,
          Nombre: e.RecintoNombre,
          NumSesionId: 0,
          RecintoId: e.RecintoId,
          RecintosSesionId: null,
          SesionBloqueada: 0,
          TipoAforo: '',
          TipoSesionId: 0,
          disabled: false
        }
      };
    });
    const objRecinto = [];
    const objFecha = [];
    const objResumen =[];
    const newArr = [];
    let indice = 0;
    aforosProducto.map(el => {
      if (!(el.recinto.Recinto in objRecinto)) {
        objRecinto[el.recinto.Recinto] = true;
        if (!(el.recinto.fecha in objFecha)) { objFecha[el.recinto.fecha] = true;}
        if (!(el.resumen in objResumen)) {objResumen[el.resumen] = true;}         
          el.index = indice;
          indice++;
          newArr.push(el);
      } else if (!(el.recinto.fecha in objFecha)) { 
          objFecha[el.recinto.fecha] = true;
          if (!(el.resumen in objResumen)) {objResumen[el.resumen] = true;} 
          el.index = indice;
          indice++;
          newArr.push(el);
      } else if (!(el.resumen in objResumen)) {
        objResumen[el.resumen] = true;
        el.index = indice;
        indice++;
        newArr.push(el);
      } 
    });
    aforos.push(...newArr);
    // aforos.flat(1);
    return aforos;
  }

  //manieva
  //si tenemos visitas y espectaculos en el mismo carrito
  //para entre otras cosas controlar el flujo separado
  esEntradaCombinada():boolean {
    // recintos en las visitas que tengan su entrada en el array
    // sumado a los que espectaculos que no tienen elementos en recinto y si un idRecintoButaca
    // También considera entradas de amigos thyssen, tienda y restauración como "sin recintos"
    console.log('entradas:: ', this.carritoValue.entradas)
    
    // Validar que existan entradas
    if (!this.carritoValue.entradas || this.carritoValue.entradas.length === 0) {
      return false;
    }
    
    // Filtrar entradas que SÍ requieren recintos (excluir amigos thyssen, tienda, restauración)
    const entradasConRecintosReales = this.carritoValue.entradas.filter(e => 
      e.entrada && 
      'recintos' in e.entrada && 
      e.entrada.recintos && 
      Array.isArray(e.entrada.recintos) &&
      e.entrada.recintos.length > 0 &&
      (!(e.entrada.DNIAbonadosExt && e.entrada.DNIAbonadosExt !== '') || !!e.entrada.desdeAsociado) &&
      e.entrada.TipoProducto !== '2'
    );

    // Filtrar entradas sin recintos pero con idRecintoButaca (espectáculos)
    const entradasSinRecintosConIdButaca = this.carritoValue.entradas.filter(e => 
      e.entrada && 
      e.entrada.recintos && 
      Array.isArray(e.entrada.recintos) &&
      e.entrada.recintos.length == 0 && 
      e.entrada.idRecintoButaca
    );

    // Filtrar entradas de amigos thyssen, tienda y restauración (no requieren recintos)
    const entradasSinRecintosEspeciales = this.carritoValue.entradas.filter(e => 
      e.entrada && (
        ((e.entrada.DNIAbonadosExt && e.entrada.DNIAbonadosExt !== '') && !e.entrada.desdeAsociado) ||
        e.entrada.TipoProducto === '2'
      )
    );

    // Es combinada si hay entradas con recintos Y (espectáculos O entradas especiales)
    return entradasConRecintosReales.length > 0 && 
           (entradasSinRecintosConIdButaca.length > 0 || entradasSinRecintosEspeciales.length > 0);
  }

  checkConAforo = () : boolean => { 
    let exist;
    let conAforo = false;
    if(this.carritoValue.entradas && this.carritoValue.entradas.length > 0) {
      // Filtrar solo entradas que SÍ requieren verificación de aforo.
      // Excluir: amigos thyssen (DNIAbonadosExt) salvo asociado.
      // Incluir promoción (TipoProducto '2') si sus recintos controlan aforo en taquilla (CP01).
      const entradasParaVerificar = this.carritoValue.entradas.filter(item => 
        (!(item.entrada.DNIAbonadosExt && item.entrada.DNIAbonadosExt !== '') || !!item.entrada.desdeAsociado)
      );
      
      entradasParaVerificar.forEach(item => {
        if(item.entrada.recintos && item.entrada.recintos.length > 0) {
          exist = item.entrada.recintos.find(val => val.ControlaAforo !== '0');
          if(exist) {
            conAforo = true;
          }
        }
      }); 
    }
    return conAforo;
  };

  /**
   * Verifica si las entradas en el carrito tienen horarios completos.
   *
   * @returns {boolean} - Devuelve true si las entradas tienen horarios completos, de lo contrario false.
  */
  esEntradaConHorariosCompletos() : boolean { 
    const checkConAforoResult = this.checkConAforo();
    if(!checkConAforoResult) {
      return true;
    }

    if(!this.recintosService.recintosValue) {
      return false;
    }
    //existen combinaciones donde no tenemos siquiera recintos
    //que es en entradas sin horarios
    //por ende esta validacion no tiene efecto
    if (this.recintosService.recintosValue && this.recintosService.recintosValue.length == 0)
      return true;

    let sumEntradas = 0;
    let sumHorarios = 0;
    let flagPromociones = false;
    let recintos = new Set();
    let recintosHorarios = new Set();
    let recintosIguales = true;

    // Filtrar entradas que SÍ requieren validación de horarios.
    // Excluir: amigos thyssen (DNIAbonadosExt) salvo asociado.
    // Incluir promoción (TipoProducto '2') para mismas reglas que entradas simples (CP01).
    const entradasParaValidar = this.carritoValue.entradas
      .map((element, index) => ({ element, index }))
      .filter(({ element }) =>
        (!(element.entrada.DNIAbonadosExt && element.entrada.DNIAbonadosExt !== '') || !!element.entrada.desdeAsociado)
      );
    const indicesEntradasParaValidar = new Set(
      entradasParaValidar.map((entrada) => entrada.index)
    );

    // Si todas las entradas son de amigos thyssen, tienda o restauración, no necesitan validación de horarios
    if (entradasParaValidar.length === 0) {
      return true;
    }
    flagPromociones = entradasParaValidar.some(({ element }) => 
      element.entrada.PromocionEntradas && element.entrada.PromocionEntradas.length > 0
    );
    // Suma de entradas y recintos disponibles filtrando por controlaAforo distinto a 0 y EsActividad igual a 0
    // Se multiplica la cantidad de entradas por la cantidad de entradas validas.
    if (flagPromociones) {
      this.carritoValue.horarios.forEach(element => {
        if(element.recinto.EsActividad === '0')
          sumEntradas += element.cantidad || 1;
        if(element.EsButaca === true)
          sumEntradas += 1;
      });
    
      entradasParaValidar.forEach(({ element }) => {
        element.entrada.recintos
          .filter(recinto => recinto.ControlaAforo !== '0' && recinto.EsActividad === '0')
          .forEach(recinto => recintos.add(recinto.Recinto));
      });
    }

    entradasParaValidar.forEach(({ element }) => {
      let cantidadEntradas = element.cantidad;
      element.entrada.recintos.forEach(entrada => {
        if(flagPromociones) {
          if(entrada.ControlaAforo !== '0' && entrada.EsActividad === '0' && !recintos.has(entrada.Recinto))
            sumEntradas += 1 * cantidadEntradas;
        } else {
          if(entrada.ControlaAforo !== '0' && entrada.EsActividad === '0')
            sumEntradas += 1 * cantidadEntradas;
        }
      });
      if(element.entrada.auditorio == true)
        sumEntradas += element.cantidad;
    })

    // Suma de horarios disponibles siempre y cuando EsActividad es igual a 0
    // Se suma el elemento para auditorios si EsButaca igual a true
    this.carritoValue.horarios.forEach(element => {
      // En compras mixtas, solo validamos horarios de entradas que requieren horario.
      const horarioPerteneceAEntradaValidable =
        element.indiceEntrada === undefined ||
        element.indiceEntrada === null ||
        indicesEntradasParaValidar.has(element.indiceEntrada);
      if (!horarioPerteneceAEntradaValidable) {
        return;
      }
      if(element.recinto.EsActividad === '0') {
        // El backend puede devolver un horario agregando varias entradas en `cantidad`.
        // Aquí debemos respetar ese agregado para no infra-contar en flujos no secuenciales.
        sumHorarios += element.cantidad || 1;
        recintosHorarios.add(element.recinto.Recinto);
      }
      if(element.EsButaca == true)
        sumHorarios += 1;
    });
    // se agrega un flag en caso de que vengan promociones ya que no coinciden con los horarios y
    // dejar que avance a la sgte instancia.
    // Verificación de igualdad de recintos.
    if (flagPromociones && !this.arraysHaveSameValues(recintos, recintosHorarios)) {
      recintosIguales = false;
    }
    if(sumEntradas !== sumHorarios || !recintosIguales) {
        return false;
    }
    // Verificamos que todos los recintos obligatorios tienen horarios seleccionados.
    if(this.fechaSeleccionadaValue === '') { 
    // Si no hay fecha seleccionada, utilizamos la fecha del carrito.
      this.setFechaSeleccionadaValue(this.carritoValue.fecha);
    }

    const recintosObligatoriosValidables = new Set<string>();
    entradasParaValidar.forEach(({ element }) => {
      element.entrada.recintos
        .filter(
          (recinto) =>
            recinto.obligatorio === true &&
            recinto.ControlaAforo !== '0' &&
            recinto.EsActividad === '0'
        )
        .forEach((recinto) => recintosObligatoriosValidables.add(recinto.Recinto));
    });
    if (recintosObligatoriosValidables.size > 0) {
      const recintosConHorario = new Set(
        this.carritoValue.horarios
          .filter((horario) => horario?.recinto?.EsActividad === '0')
          .map((horario) => horario.recinto.Recinto)
      );
      const obligatorioOk = Array.from(recintosObligatoriosValidables).every(
        (recintoId) => recintosConHorario.has(recintoId)
      );
      return obligatorioOk;
    }
    
    // Si todas las validaciones pasan, devolvemos true.
    return true;
  }


 /**
 * Verifica si dos arreglos tienen los mismos valores, independientemente del orden.
 *
 * @param {any[]} arr1 - Primer arreglo a comparar.
 * @param {any[]} arr2 - Segundo arreglo a comparar.
 * @returns {boolean} - Devuelve true si los arreglos tienen los mismos valores, de lo contrario false.
 */
  arraysHaveSameValues(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();
    return sortedArr1.every((value, index) => value === sortedArr2[index]);
  }

  consultarPagoSINPE(tipoCedula: string, numDocumento: string): Observable<any> {
    if (!tipoCedula || !numDocumento) {
      throw new Error(
        'Debe seleccionar un tipo de cédula e ingresar un número de identificación'
      );
    }

    const url = `${this.urlApi}/api/Pagos/SINPE/ConsultarPago`;

    const params = new HttpParams()
      .set("Importe", '1')
      .set('Plataforma', '2')
      .set('TipoDocumento', tipoCedula)
      .set('IdClienteOrigen', numDocumento)
    
    return this.http.get(url, { params });
    
    // return of({
    //   DatosResult: {
    //     codRespuesta: 1,
    //     descripcion: "Pago encontrado.",
    //     Pagos: [
    //       {
    //         numTelefonoDestino: 81818181,
    //         numTelefonoOrigen: 88888888,
    //         moneda: 1,
    //         monto: 1000.00,
    //         idClienteOrigen: "02-0123-0123",
    //         nombreCliente: "Josué Quesada Castillo",
    //         codReferencia: "4402416244440241624444024",
    //         codReferenciaBanco: "4402416244",
    //         descripcion: "Pago de compra Josué",
    //         fechaRecibido: "2022-0329T15:46:54.017",
    //       },
    //     ],
    //   },
    //   Mensajes: [],
    // });
  }

  vincularPagoSINPE(numeroPedido: string, listadoSINPE: { CodReferencia: string }[]): Observable<SinpeVinculacionResponse | {}> {
    if (!numeroPedido) {
      throw new Error('Debe proporcionar un número de pedido válido.');
    }
    if (!listadoSINPE || listadoSINPE.length === 0) {
      throw new Error('Debe proporcionar al menos un código de referencia SINPE.');
    }
  
    const url = `${this.urlApi}/api/Pagos/SINPE/VincularPago`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('tokenMicroservice')}`,
      'Iac-Connection-String': localStorage.getItem('conexionId') || '',
    });
  
    const body = {
      ConexionId: localStorage.getItem('conexionId'),
      Plataforma: "2",
      NumeroPedido: numeroPedido,
      ListadoSINPE: listadoSINPE,
    };

    // return of(
    //   {
    //     datosResult: {
    //         vinculacionCompletada: 0,
    //         listadoSINPE: [
    //             {
    //                 codReferencia: "2024092615031357020105190",
    //                 codRespuesta: 7,
    //                 descripcion: "El pago ya ha sido vinculado anteriormente.",
    //                 estado: 0
    //             },
    //             {
    //                 codReferencia: "2024092615031357083118046",
    //                 codRespuesta: 1,
    //                 descripcion: "El código de referencia no existe.",
    //                 estado: 0
    //             },
    //             {
    //                 codReferencia: "2024092615031357011143700",
    //                 codRespuesta: 0,
    //                 descripcion: "El pago se vinculó correctamente.",
    //                 estado:1
    //             }
    //         ]
    //     },
    //     mensajes: []
    // }
      
    // )
  
    return this.http.post(url, body, { headers })
      .pipe(
        map((res: any) => {
          if (!res || !res.datosResult) {
            return {}; // Retorna un objeto vacío si no hay datos
          }
          return res.datosResult as SinpeVinculacionResponse;
        }),
        catchError((error) => {
          console.error('Error en vincularPagoSINPE:', error);
          return throwError(() => new Error('Error al vincular el pago SINPE'));
        })
      );
  }
  
  obtenerCustomanFormaPago(): Observable<ObtenerCustomanFormaPago[]> { 
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
    };

    if (this.otherFopData.length > 0) {
      return of(this.otherFopData);
    } else {
      return this.http
        .post<ObtenerCustomanFormaPagoResponse>(
          `${this.config.getConfig('API_URL')}api/Customan/ObtenerCustomanFormaPago`,
          body
        )
        .pipe(
          tap((res: ObtenerCustomanFormaPagoResponse) => {
            this.otherFopData = res.DatosResult.customanFormaPago
          }),
          map((res: ObtenerCustomanFormaPagoResponse) => {
            if (res.DatosResult) {
              return res.DatosResult.customanFormaPago;
            }
            return [];
          }),
          shareReplay(1)
        );
    }
    
  }
    
  getMonedasBilletesChequeVaccance(): Observable<MonedasBilletesChequeVaccanceListado[]> { 
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
    };

    if (this.otherFopData.length > 0) {
      return of(this.monedasBilletesChequeVaccance);
    } else {
      return this.http
        .get<MonedasBilletesChequeVaccanceResponse>(
          `${this.config.getConfig('API_URL_MS')}/api/Maestros/MonedasBilletesChequeVaccance?ConexionId=${conexionId}`)
        .pipe(
          tap((res: MonedasBilletesChequeVaccanceResponse) => {
            this.monedasBilletesChequeVaccance = res.datosResult.listado
          }),
          map((res: MonedasBilletesChequeVaccanceResponse) => {
            if (res.datosResult) {
              return res.datosResult.listado;
            }
            return [];
          }),
          shareReplay(1)
        );
    }
    
  }
}
